<!--
 * @Author: weijinpeng jinpeng.wei@ctx.sg
 * @LastEditors: weijinpeng jinpeng.wei@ctx.sg
 * @Date: 2023-02-18 16:53:59
 * @LastEditTime: 2023-07-07 12:08:03
 * @Description: 
-->
<template>
    <div class="page">
        <Headers></Headers>
        <div class="banner">
            <div class="title_top">相关企业介绍</div>
            <div class="title_line"></div>

            <div class="box_div">
                <div class="mg_img">
                    <img src="@/assets/img/Mvgx1_0218.png" alt="">
                </div>
                <div class="right">
                    <div class="title">
                        <div class="h1">MVGX</div>
                        <div class="line"></div>
                    </div>
                    <div class="h2">MVGX成立于2018年，总部位于新加坡，是亚洲领先的数字化绿色交易和碳SaaS公司。MVGX已经建立了一个世界级的云端数字交易架构与碳足迹标签，以及纳斯达克撮合交易引擎，再加上严格的合规流程。作为元宇宙世界时代第一家受监管的交易所，MVGX拥有新加坡金融管理局（MAS）颁发的许可证，包括认可市场运营（RMO）许可证、证券交易、交易所/场外衍生品和集合投资计划交易的资本市场服务许可证，提供托管服务，以及支付服务法案（PSA）的原则批准。</div>
                </div>
            </div>

            <!-- <div class="box_div">
                <div class="mg_img">
                    <img src="@/assets/img/Acnac0218.png" alt="">
                </div>
                <div class="right">
                    <div class="title">
                        <div class="h1">ACNAC（亚洲碳中和评测中心）</div>
                        <div class="line"></div>
                    </div>
                    <div class="h2">ACNAC注册于香港，公司注册编号为2925468，简称“亚洲碳中和评测中心”或者”ACNAC”)，为新加坡MVGX Holdings Pte. Ltd.的全资子公司。亚洲碳中和评测中心专注于企业碳相关的评测业务，包括但不限于企业碳资产评测，碳足迹评测以及碳中和评测与评级。</div>
                </div>
            </div> -->

            <div class="box_div">
                <div class="mg_img">
                    <img src="@/assets/img/tuv0218.png" alt="">
                </div>
                <div class="right">
                    <div class="title">
                        <div class="h1">TÜV SÜD南德意志集团</div>
                        <div class="line"></div>
                    </div>
                    <div class="h2">TÜV SÜD南德提供安全并可持续发展的解决方案，是您值得信赖的合作伙伴。在过去的150多年里，我们借助各种各样的检测、认证、审核及知识服务，为合作伙伴及客户切实地增添了价值。我们一直致力于保护人类、环境和资产免受技术风险的影响，从而推动了社会和企业的进步 。</div>
                </div>
            </div>
            <Bottoms/>
            <div class="flxed">14</div>
        </div>
    </div>
</template>

<script>
import { reactive, toRefs, onBeforeMount, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import Headers from '../components/headers.vue'
import Bottoms from '../components/bottoms.vue'
import { usePdftStore } from '@/store/pdf'
import { formatDateTimeYYmm, formatDateTimeYY } from '@/utils/date'
export default {
    name: 'page15',
    components:{Headers, Bottoms},
    setup() {
        const data = reactive({})
        //引入数据管理库
        const PdftStore = usePdftStore()
        const formatDateTimeYYmms = (str) => {
            return formatDateTimeYYmm(str)
        }
        const formatDateTimeYYs = (str) => {
            return formatDateTimeYY(str)
        }
        onBeforeMount(() => {})
        onMounted(() => {})
        return {
            PdftStore,
            formatDateTimeYYmms,
            formatDateTimeYYs,
            ...toRefs(data),
        }
    },
}

</script>
<style scoped lang='less'>
.mag_t{
    margin-top: 20px;
}
.margin_t{
    margin-top: 10px;
}
.page{
    width: 1512px;
    height: 2149px;
    margin: 0 auto;
    background: #FFFFFF;
    position: relative;
    .banner{
        width: 100%;
        padding: 0 130px;
        .flxed{
            position: absolute;
            right: 20px;
            bottom: 20px;
            font-size: 24px;
            font-weight: 400;
            color: #333333;
            line-height: 33px;
        }
        .title_top{
            font-size: 72px;
            font-weight: 500;
            color: #013C89;
            margin: 96px 0 40px 0;
        }
        .title_line{
            width: 1252px;
            height: 2px;
            background: #013C89;
        }
        .box_div{
            width: 100%;
            margin-top: 150px;
            display: flex;
            align-items: center;
            .mg_img{
                width: 222px;
                height: 222px;
                margin-right: 48px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .right{
                width: calc(100% - 270px);
                padding-bottom: 40px;
                border-bottom: 1px solid #C5C5C6;
                .title{
                    height: 40px;
                    display: flex;
                    align-items: flex-end;
                    .h1{
                        line-height: 40px;
                        font-size: 40px;
                        font-weight: 600;
                        color: #333333;
                    }
                    .line{
                        margin-left: 10px;
                        width: 36px;
                        height: 4px;
                        background: #0DC7F5;
                    }
                }
                .h2{
                    font-size: 20px;
                    font-weight: 400;
                    color: #333333;
                    line-height: 40px;
                    text-align: justify;
                    margin-top: 40px;
                }
            }
        }
    }
}
</style>